var getDefaultChoiceGroupStyles = function (props) {
    var theme = props.theme;
    return {
        root: {},
        label: {
            color: theme.semanticColors.inputPlaceholderText,
        },
        flexContainer: {},
    };
};
export function getChoiceGroupStyles(props) {
    return getDefaultChoiceGroupStyles(props);
}
//# sourceMappingURL=ChoiceGroup.styles.js.map